<template>
    <div id="catalog">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">书籍目录</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>

        <p class="catalog">
            <span>目录</span> 共{{total}}章
            <i class="el-icon-more fr" @click="quick=!quick"></i>
            <!--<span class="r fr" v-if="order == 1" @click="doOrder(0)">正序 <i class="el-icon-arrow-down"></i></span>-->
            <!--<span class="r fr" v-if="order == 0" @click="doOrder(1)">倒序 <i class="el-icon-arrow-up"></i></span>-->

        </p>

        <ul class="quick" v-show="quick">
            <li v-for="(i,k) of getPage" :key="k" @click="setPage(i)">{{k*100+1}}-{{i*100>total ? total : i*100}}章</li>

        </ul>

        <ul style="overflow: auto;" class="catalist" v-infinite-scroll="getCatalogList">
            <li v-for="chap in chapterList">
                <router-link :to="{name:'Chapter',params:{wid:$route.params.wid,cid:chap.id}}">
                    {{chap.title}}
                    <span v-if="chap.isvip && cps == 1">VIP</span>
                    <span v-if="chap.cps_vip && cps > 1">VIP</span>
                </router-link>
            </li>

        </ul>

    </div>
</template>

<script>
    export default {
        name: "Catalog",
        data(){
            return {
                order : 1,
                page : 0,
                limit : 100,
                total : 0,
                chapterList : [],
                cps : 1,
                quick : false,
                loading : false,
                lastpage : 1
            }
        },
        computed:{
            getPage (){
                return Math.ceil(this.total / this.limit);
            }
        },
        methods : {
            getCatalogList(){

                if(this.page >= this.lastpage){
                    return;
                }
                if(this.loading){
                    return;
                }
                this.loading = true;
                this.page ++;
                this.axios.post('/api/catalog/getCatalogList',{
                    page : this.page,
                    order : this.order,
                    limit : this.limit,
                    bid : this.$route.params.wid
                }).then(r => {
                    this.loading = false;
                    let data = r.data;
                    if(data.code){
                        data.data.forEach(v => {
                            this.chapterList.push(v);
                        })

                        this.cps = data.cps;
                        this.total = data.total;
                        this.lastpage = Math.ceil(this.total / this.limit);
                    }else{
                        this.$message.error(data.msg);
                        this.$router.go(-1);
                    }

                })
            },
            setPage(page){

                this.chapterList = [];
                this.page = page;
                this.getCatalogList();
            },
            doOrder(order){
                this.order = order;
                this.page = 1;
                this.chapterList = [];
                this.getCatalogList();
            }
        },
        created() {
            // this.getCatalogList();
        }
    }
</script>

<style lang="less">
    #catalog{background: #f6f6f7;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }

        }
        .catalog{padding: 20px;font-size: 24px;color:#666;
            span{color: @theme;font-size: 30px;}
            .r{color: #666;font-size: 24px;}
            .el-icon-more{font-size: 36px;color: #999;}
        }

        .quick{background: #fff;border-bottom: 1px solid #efefef;padding: 20px 0 0 20px; overflow: auto;
            li{float: left;border:1px @theme solid;margin: 0 20px 20px 0;width: 220px;text-align: center;height: 60px;line-height: 60px;color: #666;font-size: 30px;border-radius: 8px;}
            .active{background: @theme;color: #fff;}
        }
        .catalist{background: #fff;height: calc(100% - 180px);
            li{padding: 20px;border-bottom: 1px solid #efefef;font-size: 30px;color: #333;}
            a{color: #666;}
            span{background: @theme;color: #fff;padding: 6px 20px;border-radius: 5px;font-size: 26px;float: right;}
        }

    }
</style>
